
import { useState, useEffect } from 'react';

const useVideoProgress = (userId, courseId) => {
  const [progress, setProgress] = useState({});

  
  const getStorageKey = () => `video_progress_${userId}_${courseId}`;

 
  useEffect(() => {
    if (userId && courseId) {
      const saved = localStorage.getItem(getStorageKey());
      if (saved) {
        try {
          setProgress(JSON.parse(saved));
        } catch (error) {
          console.error('Error loading video progress:', error);
          setProgress({});
        }
      }
    }
  }, [userId, courseId]);

 
  const saveLessonProgress = (lessonId, currentTime, duration) => {
    if (!lessonId || currentTime === undefined || !duration) return;

    const lessonProgress = {
      currentTime,
      duration,
      percentage: (currentTime / duration) * 100,
      lastUpdated: Date.now(),
      lessonId,
      courseId,
      userId
    };

  
    setProgress(prev => ({
      ...prev,
      [lessonId]: lessonProgress
    }));

    // Save to localStorage
    try {
      const currentProgress = { ...progress, [lessonId]: lessonProgress };
      localStorage.setItem(getStorageKey(), JSON.stringify(currentProgress));
    } catch (error) {
      console.error('Error saving video progress:', error);
    }
  };

  // Get lesson progress
  const getLessonProgress = (lessonId) => {
    if (!lessonId) return { currentTime: 0, duration: 0, percentage: 0 };
    
    const saved = progress[lessonId];
    if (!saved) return { currentTime: 0, duration: 0, percentage: 0 };

    // Check if video is nearly complete 
    const isNearlyComplete = saved.duration - saved.currentTime < 10;
    
    return {
      currentTime: isNearlyComplete ? 0 : saved.currentTime,
      duration: saved.duration,
      percentage: saved.percentage || 0
    };
  };

  // Clear all progress for this course
  const clearCourseProgress = () => {
    setProgress({});
    localStorage.removeItem(getStorageKey());
  };

  // Clear specific lesson progress
  const clearLessonProgress = (lessonId) => {
    const newProgress = { ...progress };
    delete newProgress[lessonId];
    setProgress(newProgress);
    localStorage.setItem(getStorageKey(), JSON.stringify(newProgress));
  };

  // Get all progress for the course
  const getAllProgress = () => {
    return progress;
  };

  // Calculate total watch time for course
  const getTotalWatchTime = () => {
    return Object.values(progress).reduce((total, lesson) => {
      return total + (lesson.currentTime || 0);
    }, 0);
  };

  return {
    saveLessonProgress,
    getLessonProgress,
    clearCourseProgress,
    clearLessonProgress,
    getAllProgress,
    getTotalWatchTime,
    progress
  };
};

export default useVideoProgress;